const CardData38= [
    {
    title: 'Elvis Presley',
    description:
      'Elvis Aaron Presley ​ (Tupelo, Misisipi, 8 de enero de 1935-Memphis, Tennessee, 16 de agosto de 1977), conocido como Elvis Presley, o Elvis, fue un cantante y actor estadounidense. Apodado como «el rey del rock and roll», es considerado como uno de los iconos culturales más populares del siglo XX.Nació en Tupelo (Misisipi), pero cuando tenía trece años, se mudó junto a su familia a Memphis, en Tennessee, donde en 1954 comenzó su carrera artística cuando el dueño de Sun Records, Sam Phillips, vio en él la manera de expandir la música afroamericana. Acompañado por el guitarrista Scotty Moore y el contrabajista Bill Black, fue uno de los creadores del rockabilly, un estilo de tempo rápido impulsado por un constante ritmo que consiste en una fusión de música country y rhythm and blues.Tras llegar a un acuerdo con el empresario Tom Parker, su apoderado durante casi dos décadas, la compañía discográfica RCA Records consiguió un contrato para difundir su música. El primer sencillo con esta empresa, «Heartbreak Hotel», lanzado en enero de 1956, se convirtió en un éxito número uno. Pronto, tras sus apariciones en los medios, se convirtió en la figura principal del popular sonido del rock and roll, con una serie de presentaciones televisivas y éxitos que llegaron a la cima de las listas de ventas. Sus interpretaciones llenas de energía, sobre todo de canciones afroamericanas, y su estilo desinhibido lo hicieron enormemente popular y controvertido. Meses después, en noviembre de ese mismo año, llevó a cabo su debut cinematográfico con la película Love Me Tender.Reclutado para el servicio militar en 1958, reanudó su carrera artística dos años más tarde, llegando parte de su material a alcanzar mayor éxito comercial desde entonces. Sin embargo, dio pocos conciertos en la década de 1960, guiado por Parker, se consagró a filmar películas para Hollywood y bandas sonoras, muchas de ellas ridiculizadas por la crítica. En 1968, tras siete años alejado de los escenarios, volvió a realizar actuaciones en directo en un especial de televisión que dio lugar a una amplia serie de conciertos en Las Vegas y también a varias giras musicales por Estados Unidos. En 1973 protagonizó el primer concierto televisado, de ámbito mundial vía satélite, Aloha from Hawaii, visto por casi mil quinientos millones de personas. Finalmente, el consumo excesivo de medicamentos comprometió gravemente su salud, hasta que en 1977 murió súbitamente a la temprana edad de cuarenta y dos años. Presley es considerado como una de las figuras más importantes de la cultura popular del siglo XX. American Idol se refirió a él como el más grande ídolo mundial.​ Tenía una voz versátil y un inusual éxito en muchos géneros, entre ellos el country, el pop, las baladas, el góspel y el blues. Además, es el solista con más ventas en la historia de la música popular.Nominado a catorce premios Grammy, ganó tres y recibió uno en la categoría a la carrera artística a la edad de treinta y seis años, además de figurar en diversos salones de la fama musicales.',
    videourl:
      'https://youtube.com/playlist?list=PLsLrXjai8Jf4pGeXmvzmvxjiCA_ax404J&si=tRssZmTDBwUzXa1H',
    price: 80,
    coverImg: 'elvis.gif',
    category: 'Rock Guitar',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.elvisthemusic.com/',
    youtube: 'https://www.youtube.com/channel/UCW6G95TBLCh5SdC-DHDSf5w',
    facebook: 'https://www.facebook.com/elvis',
    instagram: 'https://www.instagram.com/elvis/',
    twitter: 'https://x.com/ElvisPresley',
    spotify: 'https://open.spotify.com/artist/43ZHCT0cAZBISjO8DG9PnE?autoplay=true',
    deezer: 'https://www.deezer.com/mx/artist/1125',
    apple: 'https://music.apple.com/mx/artist/elvis-presley/197443',
    soundcloud: 'https://soundcloud.com/elvissonymusic',
    tidal: 'https://listen.tidal.com/artist/1588',
    wiki: 'https://es.wikipedia.org/wiki/Elvis_Presley',
    ticketmaster:
      'https://www.ticketmaster.com/elvis-presley-in-concert-tickets/artist/1413196',
    tiktok:
      'https://www.tiktok.com/@elvispresley?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJPED8/elvis-presley',
  },
  {
    title: 'Jerry Lee Lewis',
    description:
      'Jerry Lee Lewis (Ferriday, Luisiana, 29 de septiembre de 1935-Condado de DeSoto, Misisipi, 28 de octubre de 2022)1​2​ fue un cantante, compositor y pianista estadounidense, pionero del rock and roll. Fue ampliamente considerado como uno de los cantantes más influyentes e importantes del rock y uno de los pianistas más influyentes del siglo XX. Apodado "The Killer" ("El Asesino") por su fuerte personalidad y su puesta en escena, y tras ser considerado una seria alternativa frente a Elvis Presley, el "Rey del Rock". Su popularidad decayó a finales de los años cincuenta al hacerse público que se casó con su prima Myra Gale Brown, de 13 años de edad. Su carrera resurgió a mediados de los años 60 con varios éxitos en la música country',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_mQLD5NuPXFWFOD5h-ImrkQ76W9dwnwQoY&si=kTAd6vC--RbV9dya',
    price: '$50',
    coverImg: 'jerryleelewis.jpg',
    category: 'Rock n Roll',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://jerryleelewis.com/',
    youtube: 'https://www.youtube.com/channel/UC3PWeh1qcILzMUtNpvncQeg',
    facebook: 'https://www.facebook.com/JerryLeeLewis/',
    instagram: 'https://www.instagram.com/JerryLeeLewisTheKiller/',
    twitter: 'https://x.com/jerryleelewis',
    spotify: 'https://open.spotify.com/artist/2zyz0VJqrDXeFDIyrfVXSo',
    deezer: 'https://www.deezer.com/mx/artist/2705',
    apple: 'https://music.apple.com/mx/artist/jerry-lee-lewis/123130',
    soundcloud:'https://soundcloud.com/jerry-lee-lewis-official',
    tidal: 'https://listen.tidal.com/artist/16972',
    wiki: 'https://es.wikipedia.org/wiki/Jerry_Lee_Lewis',
    ticketmaster:
      'https://www.ticketmaster.com/jerry-lee-lewis-tickets/artist/735509',
    tiktok: 'https://www.tiktok.com/@jerry_lee_lewis',
    napster: 'https://music.amazon.com.mx/albums/B09BKNZ8Y4',
  },
  {
    title: 'Little Richard',
    description:
      'Little Richard, nombre artístico de Richard Wayne Penniman, (Macon, Georgia; 5 de diciembre de 1932-Tullahoma, Tennessee; 9 de mayo de 2020)1​2​ fue un cantante, compositor, humorista y pianista estadounidense, considerado como uno de los pioneros más influyentes e importantes de la historia del rock and roll, y una figura influyente en la música y la cultura popular durante siete décadas.Su trabajo más famoso data de mediados de la década de 1950, cuando su música dinámica y su carismático espectáculo sentaron las bases del rock and roll. Su música también jugó un papel clave en la formación de otros géneros musicales populares, como el soul y el funk. Influyó en numerosos cantantes y músicos de todos los géneros musicales, desde el rock hasta el hip hop; su música ayudó a dar forma al ritmo y al blues para las generaciones venideras, y sus actuaciones y titulares impulsaron su carrera directamente en la mezcla de la música popular estadounidense.',
    videourl:
      'https://www.youtube.com/playlist?list=OLAK5uy_ksnUWuny4_lkHq7MlNfjsXTgTFLCXnzUw',
    price: '$50',
    coverImg: 'littlerichard.jpg',
    category: 'Oldies Rock',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://concord.com/artist/little-richard/',
    youtube: 'https://www.youtube.com/channel/UCnoCTfSxdjpgc6p8_KTNgQw',
    facebook: 'https://www.facebook.com/little.richard.fans',
    instagram: 'https://www.instagram.com/littlerichardmusic/',
    twitter: 'https://x.com/LittleRichDoc',
    spotify: 'https://open.spotify.com/artist/4xls23Ye9WR9yy3yYMpAMm',
    deezer: 'https://www.deezer.com/mx/artist/4237',
    apple: 'https://music.apple.com/mx/artist/little-richard/1168275',
    soundcloud:'https://soundcloud.com/littlerichardofficial',
    tidal: 'https://listen.tidal.com/artist/1356',
    wiki: 'https://es.wikipedia.org/wiki/Little_Richard',
    ticketmaster:
      'https://www.ticketmaster.com/little-richard-tickets/artist/735520',
    tiktok: 'https://www.tiktok.com/@littlerichardofficial',
    napster: 'https://music.amazon.com.mx/artists/B000QJPEEW/little-richard',
  },
  {
    title: 'Chubby Checker',
    description:
      'Ernest Evans, conocido como Chubby Checker (Spring Gully, Carolina del Sur, 3 de octubre de 1941), es un cantante estadounidense, considerado por muchos como el Rey del twist.Nacido en Spring Gully, Carolina del Sur, y formado en Pensilvania, estudió en el South Philadelphia High School al lado de Frankie Avalon y Fabian Forte. La esposa de Dick Clark (conductor de American Bandstand) sugirió para él el nombre de Chubby Checker, como juego de palabras y alusión afectuosa al músico Fats Domino. En 1964 contrajo matrimonio con la destacada modelo holandesa, Catharina Lodders, que había sido Miss Mundo en 1962.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_lciTzW0RaxRLmrsKboUBTKxbg0bg7WpcM&si=r_omeP-1d-3U8GKq',
    price: '$50',
    coverImg: 'chubbychecker.jpg',
    category: 'Oldies Rock',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://chubbychecker.com/',
    youtube: 'https://www.youtube.com/channel/UC9174PS-AngzlCbgFlv9uWQ',
    facebook: 'https://www.facebook.com/OfficialChubbyChecker',
    instagram: 'https://www.instagram.com/officialchubbychecker/',
    twitter: 'https://x.com/chubby_checker',
    spotify: 'https://open.spotify.com/artist/7qQJQ3YtcGlqaLg5tcypN2',
    deezer: 'https://www.deezer.com/mx/artist/2202',
    apple: 'https://music.apple.com/mx/artist/chubby-checker/15147075',
    soundcloud:'https://soundcloud.com/chubby-checker-official',
    tidal: 'https://listen.tidal.com/artist/3570272',
    wiki: 'https://es.wikipedia.org/wiki/Chubby_Checker',
    ticketmaster:
      'https://www.ticketmaster.com/chubby-checker-tickets/artist/734741',
    tiktok: 'https://www.tiktok.com/search/video?q=Chubby%20Checker&t=1726206961403',
    napster: 'https://music.amazon.com.mx/artists/B000QKBKQW/chubby-checker',
  },
  {
    title: 'Ritchie Valens',
    description:
      'Richard Steven Valenzuela Reyes (Pacoima, Los Ángeles, California, 13 de mayo de 1941-Clear Lake, Iowa, 3 de febrero de 1959), conocido como Ritchie Valens, fue un músico, compositor, cantante y guitarrista estadounidense de origen mexicano. Es considerado como uno de los pioneros del rock and roll, y el primero que cantó ese género en español. Forma parte del Salón de la Fama del Rock and Roll, y fueron sus mayores éxitos las canciones We Belong Together, Come On, Lets Go, Donna y La Bamba.El día martes, 3 de febrero de 1959, conocido como «El día que murió la música», Valens murió en un accidente de avión en Iowa, un siniestro que también se cobró la vida de Buddy Holly y The Big Bopper, también músicos. Con tan solo 17 años, la vida y trayectoria de Valens quedaron truncadas.En 1987, se estrena La Bamba, película dirigida por Luis Valdez que narra la vida de Ritchie Valens (interpretado por el actor Lou Diamond Phillips), desde su ascenso musical hasta el día de su fatídica muerte. Con esta película, se volvió a retomar las canciones de Ritchie, interpretadas por el grupo Los Lobos (los mismos que realizaron y dirigieron la banda sonora del filme)',
    videourl:
      'https://youtube.com/playlist?list=UULFDeKImXX5bkZYkWOLzIjlcQ&si=RsYvx87mxLvhXtKX',
    price: '$50',
    coverImg: 'ritchievalens.jpg',
    category: 'Oldies Rock',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.ritchievalens.com/',
    youtube: 'https://www.youtube.com/@RitchieValensFanPage',
    facebook: 'https://www.facebook.com/theritchievalens/',
    instagram: 'https://www.instagram.com/ritchievalensofficial',
    twitter: 'https://x.com/chubby_checker',
    spotify: 'https://open.spotify.com/artist/5Y9xEAGW4GwGJgbiI6W85P',
    deezer: 'https://www.deezer.com/mx/artist/11731',
    apple: 'https://music.apple.com/mx/artist/ritchie-valens/1198891',
    soundcloud:'https://soundcloud.com/ritchievalensofficial',
    tidal: 'https://listen.tidal.com/artist/13461',
    wiki: 'https://es.wikipedia.org/wiki/Ritchie_Valens',
    ticketmaster:
      'https://www.ticketmaster.com/the-night-the-music-lived-a-tickets/artist/1751365',
    tiktok: 'https://www.tiktok.com/@ritchievalens12',
    napster: 'https://music.amazon.com.mx/artists/B000QJPAW8/ritchie-valens',
  },
  {
    title: 'Buddy Holly',
    description:
      'Charles Hardin Holley, más conocido como Buddy Holly (Lubbock, Texas; 7 de septiembre de 1936-Clear Lake, Iowa; 3 de febrero de 1959),4​2​ fue un cantante, compositor y guitarrista estadounidense de mediados de la década de los 50s, considerado hoy en día como uno de los pioneros del Rock and Roll. Holly fue descrito por el crítico Bruce Eder como: «La fuerza creativa más influyente del rock and roll primigenio».Si bien durante su corta trayectoria, Buddy Holly sólo alcanzó a publicar tres álbumes de estudio, su innovación y sobresaliente obra musical sirvieron de inspiración e influencia a muchos músicos y bandas posteriores como: The Beatles, The Hollies, The Beach Boys, The Rolling Stones, Cliff Richard, Bruce Springsteen, Jeff Beck, Eric Clapton, Fiona Apple, Lou Reed, Elton John, Don McLean, Bob Dylan, Brian May y Freddie Mercury,entre otros, además de ejercer una profunda y vasta influencia en la música popular',
    videourl:
      'https://youtube.com/playlist?list=PL112B34708960CED3&si=rAItwy_AjoI3mHPd',
    price: '$50',
    coverImg: 'buddyholly.jpeg',
    category: 'Oldies Rock',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.edsullivan.com/artists/buddy-holly/',
    youtube: 'https://www.youtube.com/channel/UCddPyO3i288bFhCe9mzJsqg',
    facebook: 'https://www.facebook.com/search/top?q=buddy%20holly',
    instagram: 'https://www.instagram.com/buddyhollyforever/',
    twitter: 'https://x.com/BuddyHollybrnr',
    spotify: 'https://open.spotify.com/artist/3wYyutjgII8LJVVOLrGI0D?autoplay=true',
    deezer: 'https://www.deezer.com/mx/artist/1437',
    apple: 'https://music.apple.com/mx/artist/buddy-holly/337158',
    soundcloud:'https://soundcloud.com/buddy-holly-official',
    tidal: 'https://listen.tidal.com/artist/25758',
    wiki: 'https://es.wikipedia.org/wiki/Buddy_Holly',
    ticketmaster:
      'https://www.ticketmaster.com/tribute-to-buddy-holly-tickets/artist/1021541',
    tiktok: 'https://www.tiktok.com/@buddyholly1950?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000RHPLF0/buddy-holly',
  },
  {
    title: 'Beach Boys',
    description:
      "The Beach Boys are an American rock band that formed in Hawthorne, California, in 1961. The group's original lineup consisted of brothers Brian, Dennis, and Carl Wilson, their cousin Mike Love, and friend Al Jardine. Distinguished by their vocal harmonies, adolescent-themed lyrics, and musical ingenuity, they are one of the most influential acts of the rock era. They drew on the music of older pop vocal groups, 1950s rock and roll, and black R&B to create their unique sound. Under Brian's direction, they often incorporated classical or jazz elements and unconventional recording techniques in innovative ways..",
    videourl:
      'https://youtube.com/playlist?list=PL_ZuQ6gD_Zp62U-ay5q0hEmSvrR_GbGii',
    price: 36,
    coverImg: 'theBeachBoys.png',
    category: 'Oldies Rock',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://thebeachboys.com/',
    youtube: 'https://www.youtube.com/channel/UCUxNZEOdVy77QiiSTHk8bug',
    facebook: 'https://www.facebook.com/thebeachboys',
    instagram: 'https://www.instagram.com/thebeachboys/',
    twitter: 'https://www.instagram.com/thebeachboys/',
    spotify:
      'https://open.spotify.com/artist/3oDbviiivRWhXwIE8hxkVV?autoplay=true',
    deezer: 'https://www.deezer.com/en/artist/2179?autoplay=true',
    apple: 'https://music.apple.com/us/artist/the-beach-boys/562555',
    soundcloud: 'https://soundcloud.com/thebeachboys',
    tidal: 'https://listen.tidal.com/artist/9371',
    wiki: 'https://en.wikipedia.org/wiki/The_Beach_Boys',
    ticketmaster:
      'https://www.ticketmaster.com/the-beach-boys-tickets/artist/734518',
    tiktok: 'https://www.tiktok.com/@thebeachboys',
    napster: 'https://music.amazon.com.mx/artists/B000QJPEL0/the-beach-boys',
  },
  {
    title: 'The Beatles',
    description:
      'The Beatles, también conocida en el mundo hispano como los Beatles, fue una banda de rock inglesa formada en Liverpool durante los años 1960, estando integrada desde 1962 a su separación en 1970 por John Lennon, Paul McCartney, George Harrison y Ringo Starr. Es ampliamente considerada como la banda más influyentes de todos los tiempos, siendo parte fundamental en el desarrollo del movimiento contracultural de la década de 1960 y el reconocimiento de la música popular como forma de arte.',
    videourl:
      'https://youtube.com/playlist?list=PL0jp-uZ7a4g8b4orD6OrbsVBigPO-EX9d',
    price: 36,
    coverImg: 'beatles.gif',
    category: 'Rock',
    location: 'Uk',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.thebeatles.com/',
    youtube: 'https://www.youtube.com/%20the%20beatles',
    facebook: 'https://www.facebook.com/thebeatles',
    instagram: 'https://www.instagram.com/thebeatles/',
    twitter: 'https://twitter.com/beatlesstory',
    spotify: 'https://open.spotify.com/artist/3WrFJ7ztbogyGnTHbHJFl2',
    deezer: 'https://www.deezer.com/mx/artist/1',
    apple: 'https://music.apple.com/mx/artist/the-beatles/136975',
    soundcloud:
      'https://soundcloud.com/thebeatles',
    tidal: 'https://listen.tidal.com/artist/3634161',
    wiki: 'https://es.wikipedia.org/wiki/The_Beatles',
    ticketmaster:
      'https://www.ticketmaster.com/tribute-to-the-beatles-tickets/artist/2281760',
    tiktok: 'https://www.tiktok.com/@thebeatles?lang=es',
    napster: 'https://music.amazon.com/artists/B00GB0QTOY/the-beatles',
  },
  {
    title: 'The Animals',
    description:
      'The Animals (Español: Los Animales) es una banda de rock británica formada en Newcastle upon Tyne a comienzos de la década de 1960. La agrupación se trasladó a Londres logrando reconocimiento comercial en 1964. Son reconocidos principalmente por la canción The House of the Rising Sun, aunque también publicaron otros sencillos exitosos como We Gotta Get Out of This Place, Its My Life y Dont Let Me Be Misunderstood. Fueron populares en los Estados Unidos como parte de la Invasión británica.',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nh9zMXkcuIW2R16SbH3oRoZItvBydfHQQ&si=Wx48Hufu9ZcQr_YA',
    price: 36,
    coverImg: 'theanimals.jpg',
    category: 'Oldies Rock',
    location: 'Uk',
    locationImg: 'england.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.edsullivan.com/artists/the-animals/',
    youtube: 'https://www.youtube.com/channel/UCgXfS0QdhrX55_rS4npXDow',
    facebook: 'https://www.facebook.com/TheAnimalsMusic/',
    instagram: 'https://www.instagram.com/animalsandfriendsuk/',
    twitter: 'https://x.com/Animalstheband',
    spotify: 'https://open.spotify.com/artist/3ICflSq6ZgYAIrm2CTkfVP',
    deezer: 'https://www.deezer.com/mx/artist/3350',
    apple: 'https://music.apple.com/mx/artist/the-animals/1960022',
    soundcloud:
      'https://soundcloud.com/the-animals-official',
    tidal: 'https://listen.tidal.com/artist/9867',
    wiki: 'https://es.wikipedia.org/wiki/The_Animals',
    ticketmaster:
      'https://www.ticketmaster.com/the-animals-tickets/artist/1192964',
    tiktok: 'https://www.tiktok.com/search/video?lang=es&q=The%20Animals&t=1726256788538',
    napster: 'https://music.amazon.com/artists/B00G6MJFNO/the-animals',
    
  }, {
    title: 'Royal Tj Band',
    description:
      ' Royal Tj es una destacada banda especializada en Oldies y Éxitos Versátiles, dirigida por el talentoso Sr. Carlos Denton Casillas. Con una amplia trayectoria como artista y compositor en Estados Unidos y México, el Sr. Casillas ha sabido imprimir su experiencia y pasión en cada presentación de la banda. Bajo su liderazgo, Royal Tj ofrece una experiencia musical que combina lo mejor de los clásicos con un toque versátil, cautivando a audiencias en ambos lados de la frontera.',

    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_nJTYEMSZNMPkeNEvxBsYk_pb4nWbWj7cE',
    price: '$50',
    coverImg: 'royaltj.jpg',
    category: 'Oldies',
    location: 'Mexico',
    locationImg: 'mexiflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.facebook.com/profile.php?id=1000762817078181',
    youtube: 'https://www.youtube.com/channel/UC_zud4Ek9DshahEZY5qoXGw',
    facebook: 'https://www.facebook.com/profile.php?id=1000762817078181',
    instagram: 'https://www.instagram.com/explore/tags/royaltj/',
    twitter: 'https://twitter.com/RoyalTj',
    spotify: 'https://open.spotify.com/album/7K7YDUkYRE4bJS38pMGmJF',
    deezer: 'https://www.deezer.com/en/artist/1822121',
    apple: 'https://music.apple.com/mx/artist/royal-tj-band/1529969997',
    soundcloud: 'https://soundcloud.com/user-63940145',
    tidal: 'https://music.amazon.com.mx/artists/B08H4ML16F/royal-tj-band',
    wiki:
      'https://www.amazon.com/music/player/albums/B08H4QSSNT?*entries*=0&*Version*=1',
    ticketmaster: 'https://www.viagogo.com.mx/',
    tiktok:
      'https://www.tiktok.com/music/To-Love-Some-Body-6867685115263207426',
    napster: 'https://music.amazon.com.mx/artists/B08H4ML16F/royal-tj-band',
  },
  {
    title: 'Sam Cooke',
    description:
    "Samuel Cook (Clarksdale, Misisipi, 22 de enero de 1931–Los Ángeles, 11 de diciembre de 1964), más conocido por su nombre artístico Sam Cooke, fue un cantante estadounidense de música góspel, rhythm and blues, soul y pop; compositor y empresario musical. Es uno de los pioneros de la música soul y una de las grandes influencias en la música pop, el R&B y la neo soul.Muchos lo consideran El Rey del Soul —título que comparte con Otis Redding— por haber logrado una treintena de hits entre 1957 y 1965.Fue el primer cantante negro en fundar su propia empresa discográfica, SAR Records, y también un reconocido activista dentro del Movimiento por los Derechos Civiles. Además, en su época fue uno de los artistas con mayor audiencia no negra. El documental sobre su vida: Las dos muertes de Sam Cooke, trata sobre la vida de Cooke.",
    videourl:
      "https://youtube.com/playlist?list=OLAK5uy_kBFII6F3Ac-LPCgrLFgBRPv5VSV96kDEo&si=V0P_NGBpd9naBTfF",
    price: 50,
    coverImg: 'samcooke.jpg',
    category: 'Oldies',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://officialsamcooke.com/',
    youtube: 'https://www.youtube.com/channel/UC2vyD1cRA7Wt_w5_yuwzygQ',
    facebook: 'https://www.facebook.com/officialsamcooke',
    instagram: 'https://www.instagram.com/officialsamcooke',
    twitter: 'https://x.com/officialscooke',
    spotify: 'https://open.spotify.com/artist/6hnWRPzGGKiapVX1UCdEAC?si=bTNueVBCQoCgFvbZHqAC-g&nd=1&dlsi=9d6cbe83f17f4ec9',
    deezer: 'https://www.deezer.com/en/artist/900',
    apple: 'https://music.apple.com/us/artist/sam-cooke/1195231',
    soundcloud: 'https://soundcloud.com/samcooke',
    tidal: 'https://listen.tidal.com/artist/3500082',
    wiki: 'https://es.wikipedia.org/wiki/Sam_Cooke',
    ticketmaster:
      'https://www.ticketmaster.com/the-cooke-book-tickets/artist/1830523',
    tiktok: 'https://www.tiktok.com/@officialsamcooke',
    napster: 'https://music.amazon.com.mx/artists/B000QJPXHA/sam-cooke',
  },
  {
    title: 'Aaron Neville',
    description:
    "Aaron Neville (Nueva Orleans, 24 de enero de 1941)1​ es un cantante estadounidense de R&B y soul. A lo largo de su carrera, ha obtenido cuatro álbumes de platino y cuatro Top 10 en los Estados Unidos. Famoso por su voz aguda y suave, ha cosechado éxitos como Tell It Like It Is, Even If my Heart Would Break, Don't Know Much, All My Life (junto a Linda Ronstadt) o una versión del Ave María, utilizada como cortina musical en la película ¡Viven!. Ha ganado cinco premios Grammy y publicado casi veinte álbumes en diferentes géneros musicales.También ha grabado con sus tres hermanos como los Neville Brothers y es el padre del cantante y teclista Ivan Neville.",
    videourl:
      "https://youtube.com/playlist?list=OLAK5uy_l-v6vbkkv6lduQkiNqm3mu7Z4IdzfTRck&si=roYittESxJA1Yf1P",
    price: 50,
    coverImg: 'aaronneville.jpg',
    category: 'Soul',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://aaronneville.com/',
    youtube: 'https://www.youtube.com/user/AaronNeville504',
    facebook: 'https://www.facebook.com/aaronneville504',
    instagram: 'https://www.instagram.com/aaronneville/',
    twitter: 'https://x.com/aaronneville?lang=en',
    spotify: 'https://open.spotify.com/artist/57ALvbCBaCkNlgTOSiUPdT',
    deezer: 'https://www.deezer.com/en/artist/7445',
    apple: 'https://music.apple.com/us/artist/aaron-neville/94614',
    soundcloud: 'https://soundcloud.com/aaron_neville',
    tidal: 'https://listen.tidal.com/artist/10529',
    wiki: 'https://es.wikipedia.org/wiki/Aaron_Neville',
    ticketmaster:
      'https://www.ticketmaster.com/aaron-neville-tickets/artist/735737',
    tiktok: 'https://www.tiktok.com/@.aaronneville?lang=e',
    napster: 'https://music.amazon.com.mx/artists/B000QJHVHU/aaron-neville',
  }, {
    title: 'The Temptations',
    description:
      'The Temptations es una banda estadounidense formada en Detroit, Estados Unidos. Este grupo vocal estadounidense está considerado uno de los más exitosos en la historia de la música.1​2​ Ha vendido decenas de millones de álbumes3​ y es famoso por ser una de las formaciones más relevantes de Motown Records.',
    videourl:
      'https://youtube.com/playlist?list=PLTGZr8YmZMtvTtVgaq6yesF68ahy-1VRD&si=VfVHIsG_xIQUb36',
    price: '$50',
    coverImg: 'thetemptations.jpg',
    category: 'Soul',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.temptationsofficial.com/#/',
    youtube: 'https://www.youtube.com/channel/UCee8VNCWfOCYccbFhDM8B_A',
    facebook: 'https://facebook.com/thetemptations',
    instagram: 'https://instagram.com/thetemptations/',
    twitter: 'https://x.com/thetemptations',
    spotify: 'https://open.spotify.com/artist/3RwQ26hR2tJtA8F9p2n7jG',
    deezer: 'https://www.deezer.com/mx/artist/2730',
    apple: 'https://music.apple.com/mx/artist/the-isley-brothers/121582',
    soundcloud:'https://soundcloud.com/the-temptations',
    tidal: 'https://listen.tidal.com/artist/15727',
    wiki: 'https://es.wikipedia.org/wiki/The_Temptations',
    ticketmaster:
      'https://www.ticketmaster.com/the-temptations-tickets/artist/736274',
    tiktok: 'https://www.tiktok.com/@officialtemptations',
    napster: 'https://music.amazon.com.mx/artists/B000QK1RF6/the-temptations',
  },
  {
    title: 'Aretha Franklin',
    description:
      'Aretha Louise Franklin (Memphis, 25 de marzo de 1942-Detroit, 16 de agosto de 2018)​ fue una cantante estadounidense de soul, R&B y góspel. Apodada «Lady Soul» (la Dama del Soul) o «Queen of soul» (la Reina del Soul), fue una de las mayores representante de dicho género. A mediados de la década de 1960 se consolidó como estrella femenina del Soul, algo que usó en favor de los derechos raciales en Estados Unidos, siendo un elemento influyente dentro del movimiento racial y de liberación femenina.',
    videourl:
      'https://youtube.com/playlist?list=PLCx4rpClwwTAnYs_sgXpHj3_zPsYonM_8&si=S01fDrK32mnpyYw4',
    price: '$50',
    coverImg: 'ArethaFranklin.jpg',
    category: 'Soul',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.arethafranklin.net/',
    youtube: 'https://www.youtube.com/channel/UCGDOBEUVPWkzmHo4dDa96zQ',
    facebook: 'https://www.facebook.com/arethafranklin',
    instagram: 'https://www.instagram.com/arethafranklin/',
    twitter: 'https://x.com/ArethaFranklin',
    spotify: 'https://open.spotify.com/artist/7nwUJBm0HE4ZxD3f5cy5ok',
    deezer: 'https://www.deezer.com/mx/artist/2059',
    apple: 'https://music.apple.com/mx/artist/aretha-franklin/98742',
    soundcloud:'https://soundcloud.com/arethafranklin',
    tidal: 'https://listen.tidal.com/artist/152',
    wiki: 'https://es.wikipedia.org/wiki/Aretha_Franklin',
    ticketmaster:
      'https://www.ticketmaster.com/aretha-franklin-tickets/artist/735118',
    tiktok: 'https://www.tiktok.com/@arethafranklin1942',
    napster: 'https://music.amazon.com.mx/artists/B000QJICRS/aretha-franklin',
  },
  {
    title: 'Ray Charles',
    description:
      'Ray Charles Robinson, más conocido como Ray Charles, fue un cantante, saxofonista y pianista estadounidense de soul y R&B. Entre sus amigos y músicos él prefería que le llamaran Hermano Ray y era frecuentemente referido como El Genio. Charles comenzó a perder la visión a la edad de 5 años y a los 7 años era ciego. Fue pionero de la música soul durante los años 1950 por la combinación del blues, rhythm and blues y el estilo gospel dentro de la música que grabó para el sello Atlantic. Contribuyó a la integración de la música country, rhythm and blues y música pop durante los años 1960 con su gran éxito en ABC Records, notable con sus dos álbumes de Modern Sound. Mientras estuvo con ABC, Ray Charles fue uno de los primeros músicos afroamericanos en tener control artístico en la compañía para la cual grababa.',
    videourl: 'https://youtube.com/playlist?list=PLF729174559CABBE2',
    price: '$50',
    coverImg: 'RayCharles.jpg',
    category: 'Jazz',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://raycharles.com/',
    youtube: 'https://www.youtube.com/channel/UCuDb3PN8JzDZLY-TUosFkgw',
    facebook: 'https://www.facebook.com/RayCharles',
    instagram: 'https://www.instagram.com/official.raycharles/',
    twitter: 'https://twitter.com/raycharles_tm',
    spotify: 'https://open.spotify.com/artist/1Mxqyy3pSjf8kZZL4QVxS0',
    deezer: 'https://www.deezer.com/mx/artist/1342',
    apple: 'https://music.apple.com/mx/artist/ray-charles/160926',
    soundcloud: 'https://soundcloud.com/raycharles',
    tidal: 'https://listen.tidal.com/artist/9572',
    wiki: 'https://es.wikipedia.org/wiki/Ray_Charles',
    ticketmaster:
      'https://www.ticketmaster.com/ray-charles-tickets/artist/857437',
    tiktok: 'https://www.tiktok.com/search?q=Ray%20Charles&t=1660884101665',
    napster: 'https://music.amazon.com.mx/artists/B000QJPWRG/ray-charles',
  },

  {
    title: 'James Brown',
    description:
      'James Joseph Brown fue un cantante de soul y funk estadounidense. Progenitor de la música funk y una figura importante de la música y la danza del siglo XX, a menudo se le refiere por los apodos honoríficos Padrino del Soul, Sr. Dinamita y Hermano Soul No. 1',
    videourl:
      'https://youtube.com/playlist?list=PLho6UqUrhDcXJ1yQBwcbP2mAkhGFTmcFa',
    price: '$50',
    coverImg: 'JamesBrown.jpg',
    category: 'Soul',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'http://www.jamesbrown.com/',
    youtube: 'https://www.youtube.com/channel/UCOCZxe0gNRA7c3PGWPGoiGg',
    facebook: 'https://www.facebook.com/JamesBrown',
    instagram: 'https://www.instagram.com/jamesbrown/',
    twitter: 'https://twitter.com/JamesBrownsSoul',
    spotify: 'https://open.spotify.com/artist/7GaxyUddsPok8BuhxN6OUW',
    deezer: 'https://www.deezer.com/mx/artist/1622',
    apple: 'https://music.apple.com/mx/artist/james-brown/117118',
    soundcloud: 'https://soundcloud.com/james-brown-music',
    tidal: 'https://listen.tidal.com/artist/6361',
    wiki: 'https://es.wikipedia.org/wiki/James_Brown',
    ticketmaster:
      'https://www.ticketmaster.com/james-brown-tickets/artist/734650',
    tiktok: 'https://www.tiktok.com/@jamesbrown?lang=es',
    napster: 'https://music.amazon.com.mx/artists/B000QJPCU8/james-brown',
  },
  {
    title: 'Johnny Cash',
    description:
      'Johnny Cash fue un cantante, compositor, músico, y actor estadounidense. Considerado como uno de los músicos más influyentes del siglo XX. Considerado el Rey de la Música Country y un icono de ese género. Cantautor de country, gospel, rock and roll y rockabilly, fue y es uno de los máximos representantes de la música country, aunque creó su propio subgénero musical..',
    videourl:
      'https://youtube.com/playlist?list=OLAK5uy_mrvTv_4L8MD0vAZ5JBGUA8EbSm9KTRrZ8',
    price: '$50',
    coverImg: 'JohnnyCash.jpg',
    category: 'Rock Clasico',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.johnnycash.com/',
    youtube: 'https://www.youtube.com/channel/UCLwdOhL6TKbmjRtZ8wIr-Bg',
    facebook: 'https://www.facebook.com/johnnycash',
    instagram: 'https://www.instagram.com/johnnycash/',
    twitter: 'https://twitter.com/JohnnyCash',
    spotify: 'https://open.spotify.com/artist/6kACVPfCOnqzgfEF5ryl0x',
    deezer: 'https://www.deezer.com/mx/artist/405',
    apple: 'https://music.apple.com/mx/artist/johnny-cash/70936',
    soundcloud: 'https://soundcloud.com/johnnycash',
    tidal: 'https://listen.tidal.com/artist/156',
    wiki: 'https://es.wikipedia.org/wiki/Johnny_Cash',
    ticketmaster:
      'https://www.ticketmaster.com/johnny-cash-tribute-tickets/artist/1010893',
    tiktok: 'https://www.tiktok.com/@johnnycash?lang=es',
    napster: 'https://music.amazon.com/artists/B000QJO1ZA/johnny-cash',
  },
  {
    title: 'Chet Atkins',
    description:
      'Chester Burton "Chet" Atkins (20 de junio de 1924 – 30 de junio de 2001) fue un influyente guitarrista y productor de country. Su estilo —inspirado por Merle Travis, Django Reinhardt, George Barnes y Les Paul— le trajo admiradores dentro y fuera de la escena de EE. UU. Atkins produjo discos para Eddy Arnold, Don Gibson, Jim Reeves, Connie Smith, y Waylon Jennings. Creó, junto a Owen Bradley, el estilo de música country más suave y tranquilizador conocido como sonido Nashville, que llevó el gusto por la música country a admiradores de la música pop para adultos..',
    videourl:
      'https://youtube.com/playlist?list=PLF-cRDh2mrlWh3XECQmwAggRs2-WMnlr0&si=_ajc7XmACic8_bnW',
    price: 80,
    coverImg: 'chetatkins.jpeg',
    category: 'Country Guitar',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.misterguitar.us/',
    youtube: 'https://www.youtube.com/channel/UCBH-9udLbWZBO3gIrWnwIiw',
    facebook: 'https://www.facebook.com/chet.atkins.121',
    instagram: 'https://www.instagram.com/officialchetatkins/',
    twitter: 'https://twitter.com/chetatkins757',
    spotify: 'https://open.spotify.com/artist/4dZrt8Ong5t7YYpvbfp0RU',
    deezer: 'https://www.deezer.com/mx/artist/7635',
    apple: 'https://music.apple.com/mx/artist/chet-atkins/212083',
    soundcloud: 'https://soundcloud.com/chetatkinsofficial',
    tidal: 'https://listen.tidal.com/artist/137',
    wiki: 'https://es.wikipedia.org/wiki/Chet_Atkins',
    ticketmaster:
      'https://www.ticketmaster.com/chet-atkins-tickets/artist/732681',
    tiktok:
      'https://www.tiktok.com/search?lang=es&q=Chet%20Atkins&t=1693371013916',
    napster: 'https://music.amazon.com.mx/artists/B000QJO81C/chet-atkins',
  },
  {
    title: 'Tony Bennett',
    description:
      'Anthony Dominick Benedetto (3 de agosto de 1926 – 21 de julio de 2023), conocido profesionalmente como Tony Bennett, fue un cantante estadounidense de jazz y pop tradicional. Recibió numerosos galardones, incluidos 20 premios Grammy, un premio a la trayectoria y dos premios Primetime Emmy. Bennett fue nombrado Maestro del Jazz por la National Endowments for the Arts y Honrado en el Kennedy Center, además de fundar la Frank Sinatra School of the Arts en Astoria, Queens, Nueva York. Vendió más de 50 millones de discos en todo el mundo y obtuvo una estrella en el Paseo de la Fama de Hollywood.',
    videourl:
      "https://youtube.com/playlist?list=PL3ME_UgKBYJ9BtKYU3RMXW8STg24www4D&si=DYo1w9yBPdXoPHOJ",
    price: 36,
    coverImg: 'tonybennett.gif',
    category: 'Jazz Pop',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.tonybennett.com/',
    youtube: 'https://www.youtube.com/channel/UCwo4ZnAcFI-AyDsitZvBRvg',
    facebook: 'https://www.facebook.com/tonybennett',
    instagram: 'https://www.instagram.com/itstonybennett/',
    twitter: 'https://x.com/itstonybennett',
    spotify: 'https://open.spotify.com/artist/2lolQgalUvZDfp5vvVtTYV',
    deezer: 'https://www.deezer.com/mx/artist/4088',
    apple: 'https://music.apple.com/mx/artist/tony-bennett/484980',
    soundcloud: 'https://soundcloud.com/tonybennett',
    tidal: 'https://listen.tidal.com/artist/96',
    wiki: 'https://es.wikipedia.org/wiki/Tony_Bennett',
    ticketmaster:
      'https://www.ticketmaster.com/tony-bennett-tickets/artist/736666',
    napster: 'https://music.amazon.com.mx/artists/B000QJUPYG/tony-bennett',
    tiktok: 'https://www.tiktok.com/@tonybennettofficial',
  },
  {
    title: 'Frank Sinatra',
    description:
      'Frank Sinatra, nacido el 12 de diciembre de 1915 en Hoboken, Nueva Jersey, y fallecido el 14 de mayo de 1998 en Los Ángeles, California, es una de las figuras más icónicas de la música y el cine del siglo XX. Conocido por su distintiva voz y estilo, Sinatra dejó un legado duradero en la interpretación vocal masculina.Durante su carrera, Sinatra tuvo un impacto significativo en la música popular, con un total de 209 canciones que alcanzaron las listas musicales. Su habilidad para transmitir emoción y su sentido del timing en la interpretación lo hicieron destacar en un mar de talentos. Además, Sinatra es uno de los pocos artistas que cuenta con tres estrellas en el Paseo de la Fama de Hollywood, un testimonio de su influencia y éxito en diferentes facetas del entretenimiento, incluyendo la música, el cine y la televisión. Su legado sigue vivo a través de sus grabaciones y actuaciones, y su estilo sigue siendo una referencia en la interpretación vocal.',
    videourl:
      'https://youtube.com/playlist?list=PL4X0crpaJ94VethEtLl21Bng38q8nCFvG&si=ZypOEvQxf2C6X2jJ',
    price: 36,
    coverImg: 'franksinatra.gif',
    category: 'Jazz Pop',
    location: 'USA',
    locationImg: 'usaflag.jpg',
    openSpots: null,
    likes: 1000,
    websiteurl: 'https://www.sinatra.com/',
    youtube: 'https://www.youtube.com/channel/UCJtvg6ZFwzdFdtcHBqetvwg',
    facebook: 'https://www.facebook.com/sinatra',
    instagram: 'https://www.instagram.com/sinatra',
    twitter: 'https://x.com/FrankSinatra',
    spotify: 'https://open.spotify.com/artist/1Mxqyy3pSjf8kZZL4QVxS0',
    deezer: 'https://www.deezer.com/mx/artist/617',
    apple: 'https://music.apple.com/mx/artist/frank-sinatra/171366',
    soundcloud: 'https://soundcloud.com/frank-sinatra',
    tidal: 'https://listen.tidal.com/artist/362',
    wiki: 'https://es.wikipedia.org/wiki/Frank_Sinatra',
    ticketmaster:
      'https://www.ticketmaster.com/frank-sinatra-tickets/artist/1325',
    napster: 'https://music.amazon.com/artists/B000QJI8WM/frank-sinatra',
    tiktok: 'https://www.tiktok.com/@franksinatra',
  },

]
   export default CardData38;